import {
    GET_DAILY_FORECAST_BY_LATLON,
} from '../actions/forecastActions';

import { LOCATION_CHANGED } from '../actions/locationActions';

const initialState = {
    dailyForecastIsRefreshing: false
};

export function forecast(state = initialState, action) {
    switch (action.type) {
        case LOCATION_CHANGED:
        {
            return initialState;
        }

        case GET_DAILY_FORECAST_BY_LATLON.pending:
        {
            return {
                ...state,
                daily: undefined,
                dailyForecastIsRefreshing: true
            };
        }

        case GET_DAILY_FORECAST_BY_LATLON.fulfilled:
        {
            return {
                ...state,
                daily: action.payload,
                lastError: {},
                dailyForecastIsRefreshing: false
            };
        }

        case GET_DAILY_FORECAST_BY_LATLON.rejected:
        {
            return {
                ...state,
                daily: undefined,
                lastError: action.payload,
                dailyForecastIsRefreshing: false
            };
        }
    }

    return state;
}
